import { ReactNode } from 'react';
import { IconSlot, Positioned } from './styles';

/**
 * antd 4 has no `prefix` slot on Select or DatePicker (Select only gained one in 5.22), so the source
 * icon is overlaid on the control and the control's own padding is pushed across to make room. Inputs
 * use their native `prefix` and don't need this.
 */
const SourceIconPrefix = ({ icon, children }: { icon?: ReactNode; children: ReactNode }) => {
    if (!icon) return <>{children}</>;

    return (
        <Positioned>
            <IconSlot>{icon}</IconSlot>
            {children}
        </Positioned>
    );
};

export default SourceIconPrefix;
